import { render, staticRenderFns } from "./TheSchoolAdminModal.vue?vue&type=template&id=65e5969c&scoped=true&"
import script from "./TheSchoolAdminModal.vue?vue&type=script&lang=js&"
export * from "./TheSchoolAdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5969c",
  null
  
)

export default component.exports